import React from 'react'
import Form from 'react-bootstrap/Form'

function FieldLabel({ children, className = '', ...props }) {
  return (
    <Form.Label className={`text-muted fw-light ${className}`.trim()} {...props}>
      <small>{children}</small>
    </Form.Label>
  )
}

export default FieldLabel
